import React from 'react';
import { clsx } from 'clsx';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-foreground mb-1">
            {label}
          </label>
        )}
        
        <input
          ref={ref}
          className={clsx(
            'w-full px-3 py-2 border border-input rounded-lg shadow-sm placeholder-muted-foreground bg-background text-foreground',
            'focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring',
            'disabled:bg-muted disabled:text-muted-foreground',
            error && 'border-destructive focus:ring-destructive',
            className
          )}
          {...props}
        />
        
        {error && (
          <p className="mt-1 text-sm text-destructive">{error}</p>
        )}
        
        {helperText && !error && (
          <p className="mt-1 text-sm text-muted-foreground">{helperText}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';